import { Anchor, Breadcrumbs } from "@mantine/core"
import { Link } from "react-router-dom"

import { ADMIN_NAV_DIAPORAMAS } from "_constants"
import type { Wall } from "wall/types/wall.model"

export function WallBreadcrumbs({ wall }: { wall?: Wall }) {
  return (
    <Breadcrumbs separator="→">
      <Anchor component={Link} to={"/admin"}>
        Admin
      </Anchor>
      {wall ? (
        <Anchor component={Link} to="/admin/walls">
          {ADMIN_NAV_DIAPORAMAS}
        </Anchor>
      ) : (
        <span>{ADMIN_NAV_DIAPORAMAS}</span>
      )}
      {wall && <span>{wall!.name || `Wall #${wall!.id.split("-")[0]}`}</span>}
    </Breadcrumbs>
  )
}
